import React from 'react';

interface UseSliderParams<OptionsUnion extends string> {
  options: OptionsUnion[];
  initialSelectedOption: OptionsUnion;
  onChange?: (selectedOption: OptionsUnion) => void;
}

type UseSliderPayload<OptionsUnion extends string> = [
  selectedOption: OptionsUnion,
  selectOption: (option: OptionsUnion) => void,
];

/**
 * Helper for managing slider state in a type-safe way
 */
export const useSlider = <OptionsUnion extends string>({
  options,
  initialSelectedOption,
  onChange,
}: UseSliderParams<OptionsUnion>): UseSliderPayload<OptionsUnion> => {
  const [selectedOption, setSelectedOption] = React.useState<OptionsUnion>(
    initialSelectedOption,
  );

  const selectOption = React.useCallback(
    (option: OptionsUnion) => {
      if (options.includes(option)) {
        setSelectedOption(option);
        onChange?.(option);
      }
    },
    [options, onChange],
  );

  return [selectedOption, selectOption];
};
